import { render, staticRenderFns } from "./settings-communication-activity-pane.vue?vue&type=template&id=5a6a513f&scoped=true"
import script from "./settings-communication-activity-pane.vue?vue&type=script&lang=js"
export * from "./settings-communication-activity-pane.vue?vue&type=script&lang=js"
import style0 from "./settings-communication-activity-pane.vue?vue&type=style&index=0&id=5a6a513f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6a513f",
  null
  
)

export default component.exports